export const HOME_PAGE = "HOME_PAGE";
export const IS_HOME_LOADING = "IS_HOME_LOADING";
export const PRODUCT_DETAILS = "PRODUCT_DETAILS";
export const GET_SIGNUP_INPUT = "GET_SIGNUP_INPUT";
export const SIGNUP_CREATED = "SIGNUP_CREATED";
export const IS_SIGNUP_LOADING = "IS_SIGNUP_LOADING";
export const EMAIL_OTP_CREATED = "EMAIL_OTP_CREATED";
export const IS_EMAIL_OTP_LOADING = "IS_EMAIL_OTP_LOADING";
export const IS_SIGNUP_COMPLETE = "IS_SIGNUP_COMPLETE";
export const GET_LOGIN_INPUT = "GET_LOGIN_INPUT";
export const LOGIN_CREATED = "LOGIN_CREATED";
export const IS_LOGIN_LOADING = "IS_LOGIN_LOADING";
export const IS_LOGIN_COMPLETE = "IS_LOGIN_COMPLETE";
export const IS_CART_ADDED = "IS_CART_ADDED";
export const IS_CART_LOADING = "IS_CART_LOADING";
export const CART_LIST = "CART_LIST";
export const IS_QUANTITY_LOADING = "IS_QUANTITY_LOADING";
export const GET_ADDRESS_INPUT = "GET_ADDRESS_INPUT";
export const IS_ADDRESS_LOADING = "IS_ADDRESS_LOADING";
export const ADDRESS_CREATED = "ADDRESS_CREATED";
export const BUYER_DETAILS = "BUYER_DETAILS";
export const IS_ORDER_CREATED = "IS_ORDER_CREATED";
export const IS_ORDER_LOADING = "IS_ORDER_LOADING";
export const IS_CART_LIST_CALLED = "IS_CART_LIST_CALLED";
export const IS_REMOVE_FROM_CART = "IS_REMOVE_FROM_CART";
export const GET_USER_INPUT = "GET_USER_INPUT";
export const SET_USER_INPUT = "SET_USER_INPUT";
export const IS_BUYER_UPDATE_LOADING = "IS_BUYER_UPDATE_LOADING";
export const USER_UPDATED = "USER_UPDATED";
export const IS_PRODUCT_LOADING = "IS_PRODUCT_LOADING";
export const PRODUCT_LIST = "PRODUCT_LIST";
export const SELLERS_LIST = "SELLERS_LIST";
export const BRANDS_LIST = "BRANDS_LIST";
export const CATEGORIES_LIST = "CATEGORIES_LIST";
export const ORDER_LIST = "ORDER_LIST";
export const IS_ORDER_LIST_LOADING = "IS_ORDER_LIST_LOADING";
export const ORDER_DETAILS = "ORDER_DETAILS";
export const IS_ORDER_DETAILS_LOADING = "IS_ORDER_DETAILS_LOADING";
export const LOGGED_OUT = "LOGGED_OUT";
export const SET_ADDRESS_UPDATE_INPUT = "SET_ADDRESS_UPDATE_INPUT";
export const GET_UPDATE_ADDRESS_INPUT = "GET_UPDATE_ADDRESS_INPUT";
export const IS_UPDATE_ADDRESS_LOADING = "IS_UPDATE_ADDRESS_LOADING";
export const IS_ADDRESS_UPDATED = "IS_ADDRESS_UPDATED";
export const IS_CHECK_BUYER_LOADING = "IS_CHECK_BUYER_LOADING";
export const CHECK_BUYER_COMPLETED = "CHECK_BUYER_COMPLETED";
export const PASSWORD_CREATED = "PASSWORD_CREATED";
export const IS_CREATE_PASSWORD_LOADING = "IS_CREATE_PASSWORD_LOADING";
export const SET_PASSWORD_COMPLETE = "SET_PASSWORD_COMPLETE";
export const IS_SET_PASSWORD_LOADING = "IS_SET_PASSWORD_LOADING";
export const SELLER_DETAILS = "SELLER_DETAILS";
export const IS_PHONE_LOADING = "IS_PHONE_LOADING";
export const USER_INFO = "USER_INFO";
